export const REQUEST_CARD_EVENTS = {
  VIEW_PREPARING_CARD: 'view_preparingcard',
  API_TEENADDRESS_REQUEST_PHYSICAL_CARD_SCHEDULE_SUCCESS:
    'api_teenaddress_request_physical_card_schedule_success',
  API_TEENADDRESS_REQUEST_PHYSICAL_CARD_SCHEDULE_ERROR:
    'api_teenaddress_request_physical_card_schedule_error',
  SELECT_REQUEST_PHYSICAL_CARD_WITH_TEEN_DATA_SCHEDULE:
    'select_request_physical_card_with_teen_data_schedule',
  SELECT_PREPARING_CARD_CONTINUE: 'select_preparingcard_continue',
  SELECT_REQUEST_ADDRESS_CHANGE: 'select_request_address_change',
} as const;
